<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Lotação
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12" class="py-2">
                <v-text-field
                  v-model="content.local"
                  label="Local de Lotação*"
                  counter="100"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 100)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <v-col cols="6">
                <span>O local de lotação é uma escola ou creche?*</span>
                <v-radio-group
                  v-model="content.ehEscola"
                  hide-details
                  row
                  :rules="[(v) => $required(v)]"
                >
                  <v-radio
                    label="Não"
                    :value="false"
                  ></v-radio>
                  <v-radio
                    label="Sim"
                    :value="true"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-if="content.ehEscola"
                  v-model="content.codigo"
                  counter="10"
                  maxlength="10"
                  v-only-number
                  label="Código da Escola*"
                  outlined
                  dense
                  :rules="[(v) => $requiredIfTrue(v, content.ehEscola), (v) => $max(v, 10)]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center">
              <sca-gre-cidade
                v-model="content"
                required
               ></sca-gre-cidade>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Lotacao } from '~/commons/classes/lotacao';
import LotacaoService from '~/services/lotacao.service';
import GreMunicipioService from '~/services/gre-municipio.service';

export default {
  props: new DialogProps(Lotacao),
  mixins: [LotacaoService, GreMunicipioService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const lotacao = new Lotacao(this.content).format();
          return this.edit
            ? this.$editarLotacao(lotacao, lotacao.id)
            : this.$cadastrarLotacao(lotacao);
        });
      };
      if (this.$validarFormulario("Todos os campos obrigatórios devem ser preenchidos.")) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  watch: {
    'content.ehEscola': function() {
      this.content.codigo = null;
    }
  },
};
</script>
